import { ParamMap } from "utils/param/ParamType"

export const NWB_SLICE_NAME = "NWB"

export type NWBType = {
  params: ParamMap
}
